// extracted by mini-css-extract-plugin
module.exports = {"playButton":"_16e54e9","playButtonShadow":"_51d30db"};